import { render, staticRenderFns } from "./SensorReadings.vue?vue&type=template&id=74992f48&scoped=true&"
import script from "./SensorReadings.vue?vue&type=script&lang=ts&"
export * from "./SensorReadings.vue?vue&type=script&lang=ts&"
import style0 from "./SensorReadings.vue?vue&type=style&index=0&id=74992f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74992f48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VForm,VIcon,VTooltip})
